import { useEffect, useRef } from 'react';

const JumpExtentWidget = ({ view, id = 'widget-0', label = 'Jump to Extent', extent = false, position = 'top-right' }) => {
    const buttonRef = useRef();

    useEffect(() => {
        if (!view.current) return;
        view.current.ui.add(id, position);
    }, [view.current]);

    return (
        <button
            id={id}
            title={label}
            // aria-label={label}
            className="custom-widget esri-widget--button img--widget no-select"
            onClick={() => {
                if (extent) view.current.goTo(extent);
            }}
            ref={buttonRef}
        ></button>
    );
};

export default JumpExtentWidget;
